import {ReactNode} from 'react';

import {
  FeatureFlags,
  FeatureFlagsProvider,
  useWidgetTriggerParams,
} from '@stripe-internal/conversations-ui';

import {isDotComCsfSelfServeRedirectTriggerPoint} from '../../core/lib/util/triggerPoints';
import {useFlags} from '../../core/hooks/appHooks';

export function ConversationsUIFlagsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const featureFlags = useFlags();
  const {triggerParams} = useWidgetTriggerParams();
  const {
    enableUniversalHelp,
    universalHelpUseNewDesign,
    universalHelpUseDotComDesign,
    universalHelpDotComFeedbackButtons,
    universalHelpDotComNoLlm,
    universalHelpDotComCsf,
    universalHelpMessagesTopAnchored,
    universalHelpUseInlineRacEmailForm,
    universalHelpDrawerEnabled,
    consolidatedConversationsLiveAnswersRow,
    universalHelpEncourageMoreDetailFromUserMse5042,
    enableScreenshareUi,
    enableScreenshareContextProvider,
    useExtractedConversationsAssistant,
    enableUhPendingInput,
  } = featureFlags;

  const value: FeatureFlags = {
    newUniversalHelpDesign: enableUniversalHelp && universalHelpUseNewDesign,
    universalHelpDotComDesign:
      enableUniversalHelp && universalHelpUseDotComDesign,
    dotComFeedbackButtons:
      enableUniversalHelp && universalHelpDotComFeedbackButtons,
    dotComNoLlm: enableUniversalHelp && universalHelpDotComNoLlm,
    dotComCsf: enableUniversalHelp && universalHelpDotComCsf,
    dotComCsfSelfServe: isDotComCsfSelfServeRedirectTriggerPoint(
      triggerParams?.triggerPoint,
    ),
    messagesTopAnchored:
      enableUniversalHelp && universalHelpMessagesTopAnchored,
    inlineRacEmailForm:
      enableUniversalHelp && universalHelpUseInlineRacEmailForm,
    universalHelpDrawerEnabled:
      enableUniversalHelp && universalHelpDrawerEnabled,
    conversationsLiveAnswersRow:
      consolidatedConversationsLiveAnswersRow ||
      universalHelpUseDotComDesign ||
      useExtractedConversationsAssistant,
    universalHelpEncourageMoreDetailFromUserMse5042,
    enableScreenshareUi,
    enableScreenshareContextProvider,
    enableUhPendingInput,
  };

  return <FeatureFlagsProvider value={value}>{children}</FeatureFlagsProvider>;
}
